/* global S_URL, SWITCH_URL */
function getCalendarPricesURL() {
    return `${S_URL}/api/calendar.json`;
}

function getAvailabilitiesURL(propertyCode) {
    return `${SWITCH_URL}/api/properties/${propertyCode}/availability.json`;
}

module.exports = {
    externals: {
        getCalendarPricesURL,
        getAvailabilitiesURL,
    },
};
